<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Smart Trip Linker</span><br/>
      <span style="font-style: italic; font-size: 18px">find bookings with related pickups or dropoffs to optimize routing</span>
    </div>
    <div style="position: relative; font-weight: bold; font-size: 18px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
<!--      &nbsp;&nbsp;|&nbsp;&nbsp;Vehicle Type:&nbsp;<b-form-select multiple select-size="6" v-model="selected_vehicle_type" :options="vehicle_type_options" style="font-weight: bold; width:200px"/>-->
      &nbsp;&nbsp;|&nbsp;&nbsp;Match Type:&nbsp;<b-form-select v-model="selected_match_type" :options="match_type_options" style="font-weight: bold; width:145px"/>
      &nbsp;&nbsp;|&nbsp;&nbsp;Max Miles:&nbsp;<b-form-select v-model="selected_mile_threshold" :options="miles_options" style="font-weight: bold; width:70px"/>
      &nbsp;&nbsp|&nbsp;&nbsp;Time Between:&nbsp;<b-form-select v-model="selected_min_minutes" :options="minutes_options" style="font-weight: bold; width:60px"/>
      &nbsp;to&nbsp;<b-form-select v-model="selected_max_minutes" :options="minutes_options" style="font-weight: bold; width:60px"/>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button v-on:click.prevent="load_data()" :disabled="loading">Run Report</b-button>
    </div>
    <div style="position: relative; font-size: 18px; margin: 30px 100px 30px 100px" class="align-right d-flex align-items-center justify-content-center">
      <b>Vehicle Types:</b> &nbsp;&nbsp;<b-form-checkbox-group
          v-model="selected_vehicle_type"
          :options="vehicle_type_options"
      ></b-form-checkbox-group>
    </div>


    <div v-if="!loading && items.length > 0">
      <div>
        <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
          <div class="col" style="border: 1px solid grey;">{{items.length}} of {{items_full.length}}</div>
        </div>
      </div>

      <table cellspacing="5" cellpadding="5" border="1" style="background:none">
        <thead>
        <tr>
          <th>Matches</th>
          <th>Booking</th>
          <th width="150">Route Name</th>
          <th>Vehicle</th>
          <th width="100">Vehicle Type</th>
          <th>Driver</th>
          <th>Pickup Time</th>
          <th width="200">Pickup Location</th>
          <th>Dropoff Time</th>
          <th width="200">Dropoff Location</th>
          <th>Distance Between</th>
          <th>Time Between</th>
          <th width="50">Directions Between</th>
        </tr>
        </thead>
        <template v-for="item in items">
          <tr>
            <td><b-btn size="sm" @click="item.show_matches = !item.show_matches">{{item.matches.length}}</b-btn></td>
            <td><router-link target="_blank" style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + item.booking_hash }">{{ item.bookingID }}</router-link></td>
            <td>{{item.route_name}}</td>
            <td>{{item.vehicle}}</td>
            <td>{{item.vehicle_type}}</td>
            <td>{{item.driver}}</td>
            <td :style="selected_match_type == 'pickup' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{item.pickup}}</td>
            <td :style="selected_match_type == 'pickup' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{item.pickup_time}}</td>
            <td :style="selected_match_type == 'dropoff' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{item.dropoff}}</td>
            <td :style="selected_match_type == 'dropoff' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{item.dropoff_time}}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
          <tr class="match" v-for="match in item.matches" :style="item.show_matches ? '': 'display:none'">
            <td>&nbsp;</td>
            <td>{{match.bookingID}}</td>
            <td>{{match.route_name}}</td>
            <td>{{match.vehicle}}</td>
            <td>{{match.vehicle_type}}</td>
            <td>{{match.driver}}</td>
            <td :style="selected_match_type == 'dropoff' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{match.pickup}}</td>
            <td :style="selected_match_type == 'dropoff' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{match.pickup_time}}</td>
            <td :style="selected_match_type == 'pickup' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{match.dropoff}}</td>
            <td :style="selected_match_type == 'pickup' ? 'font-weight:bold; background-color: hsla(120,100%,75%,0.3)': ''">{{match.dropoff_time}}</td>
            <td>{{match.match_miles}}</td>
            <td>{{match.match_time}}</td>
            <td><a :href="match.match_directions">directions</a></td>
          </tr>
        </template>
      </table>
    </div>
    <div v-if="loading" class="text-center text-primary my-2">
      <b-spinner class="align-middle"></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_tbn_smart_routing_report,tbn_get_vehicle_types} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'trip_linker_report_tbn',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      items_full: [],
      selected_state: '',
      selected_mile_threshold: '100',
      selected_min_minutes: '120',
      selected_max_minutes: '1440',
      selected_match_type: 'pickup',
      selected_vehicle_type: '',
      match_type_options: [
        { value: 'pickup', text: 'Near Pickup' },
        { value: 'dropoff', text: 'Near Dropoff' },
      ],
      vehicle_type_options: [],
      miles_options: [
        { value: '25', text: '25' },
        { value: '50', text: '50' },
        { value: '100', text: '100' },
        { value: '200', text: '200' },
        { value: '200', text: '300' },
      ],
      minutes_options: [
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
        { value: '240', text: '4h' },
        { value: '480', text: '8h' },
        { value: '720', text: '12h' },
        { value: '1080', text: '18h' },
        { value: '1440', text: '24h' },
      ],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment().add(14, 'days')),
      details_toDate: justDate(moment().add(16, 'days')),
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields_all: [],
      fields: [
        { key: 'details', label:'Matches', sortable: true},
        { key: 'bookingID', label: 'Booking ID', sortable: true},
        { key: 'route_name', label: 'Route', sortable: true, thStyle: { width: "300px" }},
        { key: 'vehicle', label: 'Vehicle', sortable: true},
        { key: 'vehicle_type', label: 'Vehicle Type', sortable: true},
        { key: 'driver', label: 'Driver', sortable: true},
        { key: 'pickup_time', label:'Pickup Time', sortable: true, thStyle: { width: "150px" }},
        { key: 'pickup', label:'Pickup Location', sortable: true,  thStyle: { width: "350px" }},
        { key: 'dropoff_time', label:'Dropoff Time', sortable: true, thStyle: { width: "150px" }},
        { key: 'dropoff', label:'Dropoff Location', sortable: true,  thStyle: { width: "350px" }},
        { key: 'match_miles', label:'', sortable: true},
        { key: 'match_time', label:'', sortable: true},
        { key: 'match_directions', label:'', sortable: true},
      ],
      matchingFields: [
        { key: 'bookingID', label: 'Booking ID', sortable: true},
        { key: 'route_name', label: 'Route', sortable: true, thStyle: { width: "200px" }},
        { key: 'vehicle', label: 'Vehicle', sortable: true},
        { key: 'vehicle_type', label: 'Vehicle Type', sortable: true},
        { key: 'driver', label: 'Driver', sortable: true},
        { key: 'pickup_time', label:'Pickup Time', sortable: true, thStyle: { width: "150px" }},
        { key: 'pickup', label:'Pickup Location', sortable: true,  thStyle: { width: "350px" }},
        { key: 'dropoff_time', label:'Dropoff Time', sortable: true, thStyle: { width: "150px" }},
        { key: 'dropoff', label:'Dropoff Location', sortable: true,  thStyle: { width: "350px" }},
        { key: 'match_miles', label:'Miles Diff', sortable: true},
        { key: 'match_time', label:'Time Diff', sortable: true},
        { key: 'match_directions', label:'Directions', sortable: true},
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
     this.load_vehicle_types()
  },
  methods: {
    async load_vehicle_types() {
      const {value: {data = []}} = await tbn_get_vehicle_types(this.user.tenant)
      this.vehicle_type_options = data
    },
    async load_data() {
      this.loading = true
      this.items = []
      this.items_full = []
      try {
        const {value: {data = []}} = await get_tbn_smart_routing_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), this.selected_vehicle_type, this.selected_match_type, this.selected_mile_threshold, this.selected_min_minutes, this.selected_max_minutes)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.booking_filter)
        this.items = this.items.filter(item => (this.contains(item.bookingID, this.booking_filter) || this.contains(item.route_name, this.booking_filter) || this.contains(item.pickup, this.booking_filter) || this.contains(item.dropoff, this.booking_filter) || (this.contains(item.vehicle, this.booking_filter) || (this.contains(item.driver, this.booking_filter)))))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}tbn/reports/actuals/intrastate_bookings/download`,
          {
            tenant: this.user.tenant,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `intrastate-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    booking_filter() {
      this.filter_items()
    },
    selected_match_type() {
      this.items = []
    },
    details_toDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_fromDate = justDate(moment(this.details_toDate, 'MM-DD-YYYY').subtract(1, 'week').add(1, 'day'))
    },
    details_fromDate() {
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'week').add(-1, 'day'))

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        alert("please limit tag based date range to 31 days or less")
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'week').add(-1, 'day'))
      }
    },
  }
}
</script>

<style scoped>

.arrows {font-size: 22px; font-weight: bold; color: steelblue !important }

tr.match {
  background-color: #EEE !important;
  color: black;
}
</style>
